import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class EmailHasNotSubfoldersBaseValueConverter {
    toView(folders, currentFolder) {
        if(ObjectHelper.IsNotNullAndUndefined(folders) && folders.length > 0 && ObjectHelper.IsNotNullAndUndefined(currentFolder)) {
            let tempArray = folders.filter((item) => item['Parent_FK'] != null && item['Parent_FK'] == currentFolder['Id']);

            if(ObjectHelper.IsNotNullAndUndefined(tempArray) && tempArray.length > 0) {
                return false;
            }
        }

        return true;
    }
}